// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.
import { Translation } from '@shared/ui-kit/providers/translation-provider/translation';

export const COMMON = {
  oneYReturn: (
    <Translation
      i18nKey="common.oneYReturn"
      ns="popups"
      components={[<p className="text-justify" />]}
    />
  ),

  threeYReturn: (
    <Translation
      i18nKey="common.threeYReturn"
      ns="popups"
      components={[<p className="text-justify" />]}
    />
  ),

  fiveYReturn: (
    <Translation
      i18nKey="common.fiveYReturn"
      ns="popups"
      components={[<p className="text-justify" />]}
    />
  ),

  tenYReturn: (
    <Translation
      i18nKey="common.tenYReturn"
      ns="popups"
      components={[<p className="text-justify" />]}
    />
  ),

  ytdReturn: (
    <Translation
      i18nKey="common.ytdReturn"
      ns="popups"
      components={[<p className="text-justify" />]}
    />
  ),

  threeYVol: (
    <Translation
      i18nKey="common.threeYVol"
      ns="popups"
      components={[<p className="text-justify" />]}
    />
  ),

  ter: (
    <Translation
      i18nKey="common.ter"
      ns="popups"
      components={[<p className="text-justify" />]}
    />
  ),
};

export type CommonPopupName = keyof typeof COMMON;
